import { SetAppThemeAction } from '../../reducers/Theme';
import { call, takeEvery } from 'redux-saga/effects';

export function* setLastUsedTheme({ theme }: SetAppThemeAction) {
  yield call([localStorage, localStorage.setItem], 'LAST_USED_THEME', theme);
}

export function* themeSaga() {
  yield takeEvery('SET_APP_THEME', setLastUsedTheme);
}
